import script from "./LayoutAside.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutAside.vue?vue&type=script&setup=true&lang=js"

import "./LayoutAside.vue?vue&type=style&index=0&id=af196d38&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af196d38"]])

export default __exports__